<template>

    <draggable v-model="questions"
               v-bind="{handle:'.handle', animation:150}">     

        <b-container v-for="(item, index) in questions" 
                     :key="index"
                     class="p-0"
                     :style="item.SubQuestions.length ? 'margin: 30px 0' : ''">

            <b-row class="m-13-0 v-center">
                <b-col lg="6" sm="12" class="pl-0">
                    <custom-multiselect v-model="item.Question"
                                        :options="options"/>
                </b-col>

                <b-col class="p-0-5">
                    <b-button block class="draggable-button red" @click="addSubQuestion(item)">
                        + подвопрос
                    </b-button>
                </b-col>

                <b-col class="p-0-5">
                    <b-button block class="draggable-button red" @click="deleteQuestion(item)">
                        Удалить
                    </b-button>
                </b-col>

                <b-col class="p-0-10-0-5">
                    <b-button block
                              :disabled="item.Question == null" 
                              class="draggable-button green" 
                              @click="openQuestion(item)" >
                        Открыть вопрос
                    </b-button>
                </b-col>    

                <b-col cols="1" class="sort-handle handle" />

            </b-row>

            <sub-question-list v-model="item.SubQuestions"
                               :options="subQuestions"
                               :apiVersion="apiVersion"/>

        </b-container>

    </draggable>

</template>

<script>
import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import SubQuestionList from './SubQuestionList'
import AllRoutes from '@/routes/all.routes';

export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: [ Object, Array ],
        options: {
            type: Array,
            default: null
        },
        subQuestions: {
            type: Array,
            default: null
        },
        apiVersion: {
            type: String,
            default: ""
        }
    },
    computed: {
        questions:{
            get: function() {
                return this.value;
            },
            set: function(value) {
                this.$emit('update', value);
            }
        } 
    },
    methods: {
        addSubQuestion: function(item) {
            item.SubQuestions.push(null);
            this.$emit('update', this.value);
        },
        openQuestion: function(item) {
            if (item.Question.Id)
                var routeData = this.$router.resolve({ path: AllRoutes.Admin.Questions.Edit + `?id=${item.Question.Id}`, query: { 'api-Version': this.apiVersion } });
			    window.open(routeData.href, '_blank');
        },
        deleteQuestion: function(item) {
            let index = this.value.findIndex(e => e.Question == item.Question);
            this.value.splice(index, 1);
            this.$emit('update', this.value);
        }
    },
    components: {
        CustomMultiselect,
        SubQuestionList
    }
}
</script>